










import { Component, Vue, PropSync, Watch } from 'vue-property-decorator';

@Component({
    components: {
    },
    filters: {
    },
})
export default class BRSModal extends Vue {
    @PropSync('active', {
        default: false,
    })
    pActive!: boolean;

}
